import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import WarningListItem from './WarningListItem';
export default class WarningPreview extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "warning", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.warning = this.attrs.warning;
  }
  view() {
    const warnedUser = this.warning.warnedUser();
    return m(Link, {
      className: "WarningPreview",
      href: warnedUser ? app.route('user.warnings', {
        username: warnedUser.username()
      }) : '#'
    }, m(WarningListItem, {
      warning: this.warning
    }));
  }
}
flarum.reg.add('fof-moderator-warnings', 'forum/components/WarningPreview', WarningPreview);